import { motion } from "framer-motion";
import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, Reveal, StatusBadge, Overline } from "../components/Kinetic";

const HistoirePage = () => {
  const { t } = useLanguage();
  useSEO(t("histoire.metaTitle"), t("histoire.metaDesc"));
  const items = t("histoire.items");

  return (
    <div data-testid="histoire-page">
      <PageHero
        overline={t("histoire.overline")}
        titleLines={t("histoire.titleLines")}
        intro={t("histoire.intro")}
        testid="histoire"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-5xl px-6">
          <div className="relative border-l border-graphite/15 pl-8 md:pl-14">
            {items.map((item, i) => (
              <motion.article
                key={item.date}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.22, 1, 0.36, 1] }}
                className="relative pb-16 last:pb-0"
                data-testid={`timeline-item-${i}`}
              >
                <span className="absolute -left-[37px] top-1.5 h-3 w-3 border-2 border-forest bg-bone md:-left-[61px]" />
                <p className="font-mono text-sm uppercase tracking-[0.2em] text-forest">{item.date}</p>
                <h2 className="mt-3 font-display text-2xl md:text-3xl font-light tracking-tight text-graphite">
                  {item.title}
                </h2>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-graphite-soft">{item.text}</p>
                <div className="mt-4">
                  <StatusBadge status={item.status} />
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-graphite/10 bg-white py-20">
        <div className="mx-auto max-w-5xl px-6">
          <Reveal>
            <Overline>{t("histoire.legendTitle")}</Overline>
            <p className="mt-4 max-w-3xl font-display text-xl md:text-2xl font-light leading-relaxed text-graphite">
              {t("histoire.legendText")}
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default HistoirePage;
